import React, { FC } from 'react';
import clsx from 'clsx';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography, Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { useStyles } from './Panel.styles';
import { ButtonLink } from '../ButtonLink/ButtonLink';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ButtonSubmit } from '../ButtonSubmit/ButtonSubmit';
import { Hidden } from '@mui/material';
interface ITitleProps {
  title?: string;
  titleKey?: string;
  titleValues?: any;
  buttonTitle?: string;
  pathLink?: any;
  role?: string;
  icon?: any;
  handleOpen?: () => void;
  extraButtonTitle?: string;
  extraPathLink?: any;
  extraRole?: string;
  extraIcon?: any;

}
interface IProps extends ITitleProps {
  autoHeight?: boolean;
  accordion?: boolean;
  actionIcon?: React.ReactNode;
  defaultExpanded?: boolean;
  children?: React.ReactNode;
}
const Title: FC<ITitleProps> = ({ title, titleKey, titleValues, buttonTitle, pathLink, role, icon, handleOpen, extraButtonTitle, extraPathLink, extraIcon }) => {
  const { currentUser } = useSelector((state: any) => ({
    currentUser: state.UserReducer.currentUser,
  }))
  const classes = useStyles();
  if (title || titleKey) {
    return (
      <Grid container justifyContent='space-between'>
        <Typography variant="h3" component="h2">
          {title || <FormattedMessage id={titleKey} values={titleValues} />}
        </Typography>
        <Hidden only="xs">
          {titleValues === "button" ?
            <Grid  item style={{display:"flex",gap:"10px"}}>
              {currentUser?.role === "ClientAdmin" && extraButtonTitle == "upload.several" && <ButtonLink text={`documents.${extraButtonTitle}`} to={extraPathLink} icon={extraIcon} />}
              {currentUser?.role === "Admin" && buttonTitle == "addCustomer" && <ButtonLink text={`admin.users.invite.${buttonTitle}`} to={pathLink} icon={icon} />}
              {currentUser?.role === "Admin" && buttonTitle == "add.user" && <ButtonLink text={`admin.users.invite.${buttonTitle}`} to={pathLink} icon={icon} />}
              {currentUser?.role === "ClientAdmin" && buttonTitle == "add.user" && <ButtonLink text={`admin.users.invite.${buttonTitle}`} to={pathLink} icon={icon} />}
              {currentUser?.role === "ClientAdmin" && buttonTitle == "upload.button" && <ButtonLink text={`document.${buttonTitle}`} to={pathLink} icon={icon} />}
            </Grid> : null}
          {titleValues === "modelButton" ?
            <Grid item>
              <ButtonSubmit
                text={`group.user.${buttonTitle}`}
                onClick={handleOpen}
              />
            </Grid>
            : null}
        </Hidden>
        <Hidden smUp>
          {titleValues === "button" ?
            <Grid item  style={{ marginTop: '1.5rem',display:"flex",flexDirection:'column',gap:"10px" }}>
              {currentUser?.role === "ClientAdmin" && extraButtonTitle == "upload.several" && <ButtonLink text={`documents.${extraButtonTitle}`} to={extraPathLink} icon={extraIcon} className={classes.lableFontSize} />}
              {currentUser?.role === "Admin" && buttonTitle == "addCustomer" && <ButtonLink text={`admin.users.invite.${buttonTitle}`} to={pathLink} icon={icon} className={classes.lableFontSize} />}
              {currentUser?.role === "Admin" && buttonTitle == "add.user" && <ButtonLink text={`admin.users.invite.${buttonTitle}`} to={pathLink} icon={icon} className={classes.lableFontSize} />}
              {currentUser?.role === "ClientAdmin" && buttonTitle == "add.user" && <ButtonLink text={`admin.users.invite.${buttonTitle}`} to={pathLink} icon={icon} className={classes.lableFontSize} />}
              {currentUser?.role === "ClientAdmin" && buttonTitle == "upload.button" && <ButtonLink text={`document.${buttonTitle}`} to={pathLink} icon={icon} className={classes.lableFontSize} />}
            </Grid> : null}
          {titleValues === "modelButton" ?
            <Grid item>
              <ButtonSubmit
                text={`group.user.${buttonTitle}`}
                onClick={handleOpen}
                className={classes.lableFontSize}
              />
            </Grid>
            : null}
        </Hidden>
      </Grid>
    );
  }
  return null;
};
export const Panel: FC<IProps> = ({
  autoHeight,
  defaultExpanded,
  title,
  titleKey,
  children,
  accordion,
  actionIcon,
  titleValues,
  buttonTitle,
  pathLink,
  role,
  icon,
  handleOpen,
  extraButtonTitle,
  extraIcon,
  extraPathLink
}) => {
  const classes = useStyles();
  return (
    (accordion && (
      <ExpansionPanel defaultExpanded={defaultExpanded}>
        <ExpansionPanelSummary expandIcon={actionIcon ?? <ExpandMore />}>
          <Title title={title} titleKey={titleKey} titleValues={titleValues} buttonTitle={buttonTitle} pathLink={pathLink} role={role} icon={icon} handleOpen={handleOpen} extraButtonTitle={extraButtonTitle} extraPathLink={extraPathLink} extraIcon={extraIcon} />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.panelDetails}>{children}</ExpansionPanelDetails>
      </ExpansionPanel>
    )) || (
      <Card className={clsx(classes.root, { [classes.autoHeight]: autoHeight })}>
        {(title || titleKey || actionIcon) && (
          <CardHeader
            title={<Title title={title} titleKey={titleKey} titleValues={titleValues} buttonTitle={buttonTitle} pathLink={pathLink} role={role} icon={icon} handleOpen={handleOpen} extraButtonTitle={extraButtonTitle} extraPathLink={extraPathLink} extraIcon={extraIcon} />}
            action={actionIcon}
          />
        )}
        <CardContent>{children}</CardContent>
        <Outlet />
      </Card>
    )
  );
};